<div class='sm-home-container'>
<!--   <div class='sm-home-headerbar'>
  	<img class="sm-home-logo" [src]="logoUrl" />
  </div> -->
  <div [innerHTML]="homeHtml | safe: 'html'"></div>
</div>